import { getNewRelicApi, withoutUndefined } from '@makemydeal/dr-shared-ui-utils';

import { DEAL_ASSISTANT_MONITORING_EVENTS } from '../constants';
import type { DealAssistantUnavailableReason } from '../state/DealAssistantContext';

type MonitoringEventName = (typeof DEAL_ASSISTANT_MONITORING_EVENTS)[keyof typeof DEAL_ASSISTANT_MONITORING_EVENTS];

export type DealAssistantFailureDetails = {
    code: string;
    httpStatus?: number;
    causeName?: string;
};

const track = (name: MonitoringEventName, attributes: Record<string, unknown> = {}): void => {
    getNewRelicApi()?.addPageAction?.(name, withoutUndefined(attributes));
};

export const trackOpenPanel = (): void => track(DEAL_ASSISTANT_MONITORING_EVENTS.openPanel);

export const trackInputInteraction = (): void => track(DEAL_ASSISTANT_MONITORING_EVENTS.inputInteraction);

export const trackWelcomeLinkClick = (label: string): void => track(DEAL_ASSISTANT_MONITORING_EVENTS.welcomeLinkClick, { label });

export const trackSendMessage = (): void => track(DEAL_ASSISTANT_MONITORING_EVENTS.sendMessage);

export const trackSendFailed = ({ code, httpStatus, causeName }: DealAssistantFailureDetails): void =>
    track(DEAL_ASSISTANT_MONITORING_EVENTS.sendFailed, { code, httpStatus, causeName });

const errorNameOf = (error: unknown): string => (error instanceof Error ? error.name : 'unknown');

export const trackSnapshotFailed = (error: unknown): void =>
    track(DEAL_ASSISTANT_MONITORING_EVENTS.snapshotFailed, { errorName: errorNameOf(error) });

export const trackDealStructureFailed = (error: unknown): void =>
    track(DEAL_ASSISTANT_MONITORING_EVENTS.dealStructureFailed, { errorName: errorNameOf(error) });

export const trackDealStructureSkipped = (reason: DealAssistantUnavailableReason): void =>
    track(DEAL_ASSISTANT_MONITORING_EVENTS.dealStructureSkipped, { reason });
